/* PW v94.4 trust layer (14 Oct 2026)
   a) Real orders, real homes: if Liquid found no review photos, collect them from the Judge.me
      widget once it renders. The strip stays hidden when there are none.
   b) Shopify Inbox chat: navy and gold button, lifted above the sticky Add to Cart on phones.
      Works only once the Shopify Inbox app embed is switched on; does nothing otherwise. */
(function () {
  'use strict';

  /* ---------- a) review photos ---------- */
  function fillReal() {
    var strip = document.querySelector('[data-pw-real]');
    if (!strip || strip.getAttribute('data-pw-real-n') !== '0') return true;
    var imgs = document.querySelectorAll('.jdgm-rev__pic-img, .jdgm-rev__pics img, .jdgm-gallery img');
    if (!imgs.length) return false;
    var row = strip.querySelector('.pw-real__row'), seen = {}, n = 0;
    for (var i = 0; i < imgs.length && n < 10; i++) {
      var s = imgs[i].getAttribute('data-src') || imgs[i].currentSrc || imgs[i].getAttribute('src') || '';
      if (!s || s.indexOf('data:') === 0 || seen[s]) continue;
      seen[s] = 1; n++;
      var a = document.createElement('a');
      a.className = 'pw-real__it'; a.href = '#judgeme_product_reviews_wrap';
      var im = document.createElement('img');
      im.src = s; im.alt = 'Customer photo from a review'; im.loading = 'lazy'; im.width = 200; im.height = 200;
      a.appendChild(im); row.appendChild(a);
    }
    if (n) { strip.hidden = false; strip.setAttribute('data-pw-real-n', String(n)); }
    return n > 0;
  }

  /* ---------- b) chat button ---------- */
  var NAVY = '#111B38', GOLD = '#F2B544';
  function chatHost() { return document.querySelector('inbox-online-store-chat') || document.getElementById('shopify-chat'); }
  function fixedNodes(root) {
    var out = [], all = root.querySelectorAll('*');
    for (var i = 0; i < all.length && i < 400; i++) {
      var cs = getComputedStyle(all[i]);
      if (cs.position === 'fixed' && cs.display !== 'none') out.push(all[i]);
    }
    return out;
  }
  function styleChat() {
    var host = chatHost();
    if (!host) return false;
    var root = host.shadowRoot || host;
    if (!root.querySelector('style[data-pw-chat]') && host.shadowRoot) {
      var st = document.createElement('style');
      st.setAttribute('data-pw-chat', '');
      st.textContent = 'button[class*="chat-toggle"],button[aria-label*="hat"],.chat-toggle{background:' + NAVY + ' !important;color:' + GOLD + ' !important;border:2px solid ' + GOLD + ' !important;box-shadow:0 8px 22px -8px rgba(17,27,56,.6) !important}' +
        'button[class*="chat-toggle"] svg,button[aria-label*="hat"] svg,.chat-toggle svg{fill:' + GOLD + ' !important;color:' + GOLD + ' !important}';
      host.shadowRoot.appendChild(st);
    }
    place();
    return true;
  }
  function place() {
    var host = chatHost();
    if (!host) return;
    var bar = document.querySelector('[data-pw-stickybar]');
    var up = bar && window.matchMedia('(max-width: 989px)').matches && bar.classList.contains('is-up');
    var lift = up ? Math.round(bar.getBoundingClientRect().height) + 12 : 0;
    document.documentElement.classList.toggle('pw-has-sticky', !!up);
    var nodes = fixedNodes(host.shadowRoot || host);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-pw-base') === null) {
        el.setAttribute('data-pw-base', String(parseFloat(getComputedStyle(el).bottom) || 16));
      }
      var base = parseFloat(el.getAttribute('data-pw-base')) || 16;
      el.style.setProperty('bottom', (base + lift) + 'px', 'important');
      el.style.setProperty('transition', 'bottom .3s ease');
    }
  }

  function boot() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var a = fillReal(), b = styleChat();
      if ((a && b) || tries > 40) clearInterval(t);
    }, 500);
    var bar = document.querySelector('[data-pw-stickybar]');
    if (bar && 'MutationObserver' in window) {
      new MutationObserver(place).observe(bar, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', place, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
